import { XCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { OrderCancelledMessage } from '~/pages/messages/Messages';

export function OrderCancelledCard({
  msg,
}: Readonly<{ msg: OrderCancelledMessage }>) {
  const { t } = useTranslation('messages');

  return (
    <div className="flex flex-col items-center gap-1">
      <span className="text-xs text-neut-400">{msg.timestamp}</span>
      <div className="w-full max-w-md border border-error-200 rounded-lg overflow-hidden">
        <div className="flex items-center gap-2 px-4 py-2.5 bg-error-100 border-b border-error-200">
          <XCircle size={14} className="text-error-500 shrink-0" />
          <span className="text-sm font-semibold text-error-700">
            {t('messages.order_cancelled.title', {
              orderNumber: msg.orderNumber,
            })}{' '}
            ✕
          </span>
        </div>
        <div className="px-4 py-3 bg-error-100 flex flex-col gap-1">
          <p className="text-xs font-medium text-error-700">
            {t('messages.order_cancelled.reason_label', {
              reason: msg.reason ?? '',
            })}
          </p>
          <p className="text-xs text-error-600">
            {t('messages.order_cancelled.description')}
          </p>
        </div>
      </div>
    </div>
  );
}
